import { createElement, FC, FunctionComponent, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks';
import { isUndefined } from 'lodash';
import { TStep } from 'models/response/CarDetailResponse';
import { IDetailRequest } from 'models/response/InspectionResponse';
import { removeErrors, setValue } from 'store/carDetail';
import { IInput } from 'types/global';

import { IFormGen } from './FormGen';
import schemaForm from './schemaForm';

const FormGen: FC<any> = ({ form, dataApi, title, isNestedForm, property_value, step }) => {
  useEffect(() => {}, []);
  return (
    <div>
      {title && <h6 className=" tw-text-green500 tw-mt-5">{title}</h6>}
      {form.map((formItem: any) => {
        const options = formItem.key_list_api ? dataApi[formItem.key_list_api] : formItem.options;
        return (
          <div className="tw-mt-2" key={formItem.name}>
            <FormItem
              options={options}
              step={step}
              {...formItem}
              property_value={property_value}
              label={
                ((isNestedForm || form.length > 1 || form.type === 'dropdown') && formItem.label) ||
                ''
              }
              placeholder={
                isUndefined(formItem.placeholder) ? formItem.label : formItem.placeholder
              }
            />
          </div>
        );
      })}
    </div>
  );
};

const FormItem: FC<IFormGen.IField> = ({
  type,
  options,
  name,
  label,
  render_form,
  property_value,
  placeholder,
  props,
  step,
}) => {
  const schema = schemaForm[type.toUpperCase() as IFormGen.TInputType];
  const component = schema && (schema.component as FunctionComponent<any>); // or React.ComponentClass<any>
  const dispatch = useDispatch();
  const { answers, isShowError } = useAppSelector((state) => state.carDetail);
  const onChange = (event: IInput.TTarget) => {
    const { name, value } = event.target;
    if (name) {
      let newData = { name, value };
      if (property_value) {
        Object.assign(newData, { property_value });
      }
      dispatch(removeErrors(step));
      dispatch(setValue(newData));
    }
  };

  const renderForms = options?.filter((optionItem: any) => optionItem.is_render_form) || [];
  const value = property_value
    ? answers &&
      (answers as unknown as Record<TStep, IDetailRequest>)[property_value as TStep]?.[
        name as keyof IDetailRequest
      ]
    : !isUndefined(answers?.[name as keyof IDetailRequest]) &&
      answers?.[name as keyof IDetailRequest];

  const hasError =
    isShowError && (value === null || value === undefined || value === '' || value === 0);

  const errorMessage = hasError && 'This field is required';

  useEffect(() => {
    if (!(hasError && step)) {
      dispatch(removeErrors(step));
    }
  }, [hasError]);

  useEffect(() => {
    return () => {
      if (property_value) {
        const newData = { name, value: null, property_value };
        dispatch(setValue(newData));
      }
    };
  }, [property_value]);

  return (
    <div>
      {component
        ? createElement(component, {
            options,
            name,
            onChange,
            label,
            value,
            hasError,
            errorMessage,
            placeholder,
            ...props,
          })
        : String(type)}
      {renderForms.length > 0 &&
        renderForms.map((renderFormItem) => {
          const isShow =
            (!isUndefined(answers?.[name as keyof IDetailRequest]) &&
              renderFormItem?.id === answers?.[name as keyof IDetailRequest]) ||
            renderFormItem.value === answers?.[name as keyof IDetailRequest];
          return (
            isShow && (
              <FormGen
                isNestedForm
                key={renderFormItem}
                property_value={render_form.property_value || property_value}
                form={render_form.form}
                title={render_form.title_form}
              />
            )
          );
        })}
    </div>
  );
};

export default memo(FormGen);
